module.exports = __webpack_public_path__ + "media/reference2.fddc4288.mp3";